<template>
  <!--
<ChartRing :data="customerCountSourceDataList" :view="[getLanguageStr('crm1','全部客户'),objTool(customerCountSourceData,'sum')]" :sizeClass="'h9x'" class="w10x-min"></ChartRing>
 -->
  <div class="chartBox" :class="chartClass">
    <Loading ref="loading"></Loading>
    <div v-if="data.length>0" class="chart pt1x" :class="chartClass"></div>
    <NoResult v-if="data.length==0" :class="chartClass"></NoResult>
  </div>
</template>
<script>
import * as lib from '@/util/lib.js'
import Loading from '@/components/common/ui/Loading.vue'
import NoResult from '@/components/common/ui/NoResult.vue'
import { drawColumn } from '@/util/chart.js'
export default {
  name: 'ChartColumn',
  components: { Loading, NoResult },
  props: {
    data: {
      type: Array,
      default: function () {
        return []
      }
    },
    option: {
      type: Object,
      default: function () {
        return {
          yTitle: ['']
        }
      }
    },
    chartClass: {// 图表需要的class
      type: String,
      default: ''
    }
  },
  data () {
    return {
    }
  },
  watch: {
    data: function (data) {
      this.run()
    }
  },
  methods: {
    rebuildData (data, option) {
      let resultData = null
      if (data && option) {
        // option.yTitle = []
        resultData = data.map(item => {
          if (item.unit && lib.unitinclude(item.unit)) {
            // if (option.yTitle.indexOf(item.unit) !== -1) option.yTitle.splice(option.yTitle.indexOf(item.unit), 1)
            // console.log(item.unit.length, item.unit)
            let dataitem = this.changeUnit(item.data, item.unit.length > 1 ? item.unit.substr(0, 1) : item.unit, item.unit.length > 1 ? item.unit.substr(1, item.unit.length) : '')
            // console.log(dataitem)
            option.yTitle.includes(dataitem[0][2]) ? option.yTitle = _.cloneDeep(option.yTitle) : (dataitem[0][2] ? option.yTitle.push(dataitem[0][2]) : item.unit ? option.yTitle.push(item.unit) : _.cloneDeep(option.yTitle))
            item.unit = dataitem[0][2] ? dataitem[0][2] : item.unit
            item.data = dataitem[1]

            return item
          } else {
            option.yTitle.includes(item.unit) ? option.yTitle = _.cloneDeep(option.yTitle) : item.unit ? option.yTitle.push(item.unit) : option.yTitle = _.cloneDeep(option.yTitle)
          }

          return item
        })
      }
      let usedUnit = resultData.map(item => {
        return item.unit
      })
      option.yTitle = Array.from(new Set(option.yTitle))
      option.yTitle = option.yTitle.filter(item => {
        return usedUnit.includes(item)
      })
      resultData.map(item => {
        item.yAxis = option.yTitle.indexOf(item.unit)
        item.yAxis = item.yAxis !== -1 ? item.yAxis : 0
      })
      //  console.log(resultData, option)
      return [resultData || data, option]
    },
    changeUnit (data, origin, initNine) {
      // console.log(initNine)
      let max = data.reduce((item1, item2) => {
        return Math.abs(item1) >= Math.abs(item2) ? item1 : item2
      })
      let copyMax = max
      // console.log(this.convertData(max.generationValue, 2, 'k', 'Wh', false)[2])
      let unit = origin === 'W' ? 'W' : lib.convertData(max, 2, origin, initNine, false)[2] ? lib.convertData(max, 2, origin, initNine, false)[2].substr(0, 1) : ''
      // console.log(unit)
      let resdata = data.map(item => {
        if (item != null && item != '') {
          if (unit === 'k') {
            item = lib.floatFix(Number(item), 2, null, false, false)
          } else if (unit === 'M') {
            item = lib.floatFix(Number(item) / 1000, 2, null, false, false)
          } else if (unit === 'G') {
            item = lib.floatFix(Number(item) / 1000000, 2, null, false, false)
          } else if (unit === 'W') {
            if (copyMax > 1000000000 || copyMax < -1000000000) {
              item = lib.floatFix((item / 1000000000), 2, null, false, false)
            } else if (copyMax > 1000000 || copyMax < -1000000) {
              item = lib.floatFix((item / 1000000), 2, null, false, false)
            } else if (copyMax > 1000 || copyMax < -1000) {
              item = lib.floatFix(item / 1000, 2, null, false, false)
            } else {
              item = lib.floatFix(item, 2, null, false, false)
            }
          }
        }
        return item
        // item.generationValue = this.convertData(item.generationValue * 1000, null, 'k', 'Wh', false)
      })
      if (unit === 'W') {
        return [[copyMax + this.wunit(copyMax) + 'W', copyMax, this.wunit(copyMax) + 'W'], resdata]
      } else {
        return [lib.convertData(copyMax, 2, origin, initNine, false), resdata]
      }
    },
    wunit (data) {
      if (data > 1000000000 || data < -1000000000) return 'G'
      else if (data > 1000000 || data < -1000000) return 'M'
      else if (data > 1000 || data < -1000) return 'k'
      else return ''
    },
    run: function () {
      this.$nextTick(() => {
        this.hideLoading()
        // $("#"+this.id).addClass(this.sizeClass);
        if (!this.option.dataHover) {
          this.option.dataHover = data => { // 判断并追加数据交互输出
            this.$emit('DataHover', data)
          }
        }
        // console.log(this.option)
        let arrres = this.rebuildData(_.cloneDeep(this.data), _.cloneDeep(this.option))
        let rd = arrres[0]
        let opt = arrres[1]
        if (this.data.length > 0) drawColumn($(this.$el).find('.chart')[0], rd, opt)
      })
    },
    showLoading () {
      this.$refs.loading.show()
    },
    hideLoading () {
      this.$refs.loading.hide()
    }
  },
  created () { },
  mounted () {
    // trace(this.data)
  }
}
</script>
<style lang="scss" scoped>
</style>



// WEBPACK FOOTER //
// src/components/common/chart/ChartColumn.vue